import React from "react";
// import useUser from "../Context/hook/useUser";
import UserImg from "../Assets/img/no-user.jpg";
import { AiOutlineClose } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { FiLogOut } from "react-icons/fi";
import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";
import { useState } from "react";
import { useRef } from "react";
import { useMediaQuery } from "react-responsive";

export const Navbar = ({ toggle, active, authMenu, noAuthMenu }) => {
  // const { isAuth, getUser, logout } = useUser();
  const [open, setOpen] = useState(false);
  // const user = getUser();
  // const navigate = useNavigate();

  const bodyRef = useRef(document.body);

  const isPhonePortOrMinor = useMediaQuery({
    query: "(max-width: 56.25em)",
  });

  useEffect(() => {
    if (active && isPhonePortOrMinor) bodyRef.current.style.overflow = "hidden";
    else bodyRef.current.style.overflowY = "auto";
    return () => {
      bodyRef.current.style.overflowY = "auto";
    };
  }, [active]);

  const NoAuthMenu = () => (
    <div className="text-font-muted font-normal text-3xl flex flex-col gap-y-4">
      {noAuthMenu.map((menu, i) => (
        <Link
          key={i}
          to={menu.redirect}
          onClick={() => toggle(false)}
          className="pl-6 py-4 rounded-md hover:text-white hover:font-medium hover:bg-[#303030]"
        >
          <div className="flex items-center gap-x-4">
            {menu.icon}
            <span>{menu.title}</span>
          </div>
        </Link>
      ))}
    </div>
  );

  const userImage = localStorage.getItem("userImage");

  const AuthMenu = () => (
    <div className="text-font-muted font-normal text-3xl flex flex-col gap-y-4">
      {authMenu.map((menu, i) => (
        <Link
          key={i}
          to={menu.redirect}
          onClick={() => toggle(false)}
          className="pl-6 py-4 rounded-md hover:text-white hover:font-medium hover:bg-[#303030]"
        >
          <div className="flex items-center gap-x-4">
            {menu.icon}
            <span>{menu.title}</span>
          </div>
        </Link>
      ))}
      <button
        onClick={() => {
          toggle(false);
          handleDialog(true);
        }}
        className="pl-6 py-4 rounded-md hover:text-white hover:font-medium hover:bg-[#303030]"
      >
        <div className="flex items-center gap-x-4">
          <FiLogOut />
          <span>Cerrar Sesión</span>
        </div>
      </button>
    </div>
  );

  // const onLogout = () => {
  //   logout();
  // };

  const handleDialog = (option) => {
    setOpen((cur) => option);
  };

  const LogOutDialog = () => (
    <Dialog open={open} onClose={() => handleDialog(false)}>
      <DialogTitle id="alert-dialog-title">
        {"¿Estás seguro que deseas cerrar sesión?"}
      </DialogTitle>
      <DialogActions>
        <Button
          onClick={() => {
            handleDialog(false);
            toggle(true);
          }}
        >
          Cancelar
        </Button>
        {/* <Button
          onClick={() => {
            onLogout();
            handleDialog(false);
          }}
          autoFocus
        >
          Aceptar
        </Button> */}
      </DialogActions>
    </Dialog>
  );

  return (
    <div
      className={`h-[100%] fixed top-0 right-0 z-50 sidebar ${
        active ? "active" : ""
      }`}
    >
      <LogOutDialog></LogOutDialog>
      <div className="sticky top-0 bg-dark text-white p-2 w-[100vw] tab-port:w-[50vw] tab-land:w-[23vw] h-screen">
        <div className="block text-right mt-4 mr-2">
          <button
            className="text-4xl p-2 bg-transparent rounded-full text-white hover:bg-bd-light hover:text-danger"
            onClick={() => toggle(false)}
          >
            <AiOutlineClose></AiOutlineClose>
          </button>
        </div>
        {/* <div className="flex flex-col px-14 py-16">
          {isAuth() && (
            <div className="flex items-center gap-x-8">
              <div className="">
                <img
                  src={userImage ? userImage : UserImg}
                  alt="user"
                  className="w-[10rem] rounded-full"
                />
              </div>
              <span className="text-2xl font-medium">{user?.fullName}</span>
            </div>
          )} */}
          <div className="mt-12 text-xl">
            {<NoAuthMenu></NoAuthMenu>}
          </div>
        </div>
      </div>
    // </div>
  );
};
